import placeholderImage from '@/assets/adv_space_placeholder_large.png';

export const isPlaceholderFile = (file: { thumbnail?: string } | null | undefined): boolean =>
  !file || !file.thumbnail || file.thumbnail === placeholderImage;
